// extracted by mini-css-extract-plugin
module.exports = {"actions":"Quantity_actions__C9fVt","input":"Quantity_input__yBzs3"};